module.exports = __webpack_public_path__ + "static/media/icon_globe.ddd01ffd.png";